<template>
  <div class="row mt-4">
    <div class="col-7 text-uppercase">
      <h4><b>Importar clientes por Excel</b></h4>
    </div>

    <div class="col-5">
      <b-row
        class="align-items-center border-r5 p-2 pointer"
        style="border: 1px dashed #007bff; background-color: #eee; width: 100%"
        @click="baixarExcel()"
      >
      
        <b-col cols="10">
          <span style="color:red"><b>E-mail, cpf, nome e sobrenome</b> são obrigatórios, o restante é opcional!</span><br>
          Baixar planilha de exemplo</b-col>
        <b-col class="text-right">
          <i class="fas fa-cloud-download-alt fs-30 text-primary"></i>
        </b-col>
      </b-row>
    </div>

    <div class="col-2 mt-4">
      <label>Id Lojista:</label>
      <input type="text" class="form-control" placeholder="####" @blur="buscarLojista()" v-model="lojista_id">
    </div>

    <div class="col-5 mt-4">
      <label>Lojista selecionado:</label>
      <input type="text" class="form-control" placeholder="Selecione um lojista" readonly v-model="lojista_nome">
    </div>

    <div class="col-5 mt-4">
      <b-row 
        class="align-items-center border-r5 p-2 pointer mt-4" 
        style="border: 1px dashed #28a745; background-color: #eee; width:100%"
      >
        <b-col cols="10">
          <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload">
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-cloud-upload-alt fs-30 text-success"></i>
        </b-col>
      </b-row>
    </div>

    <div class="col-12 mt-4" v-if="clientes != null && clientes.length">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-left">Nome</th>
            <th class="text-left">Sobrenome</th>
            <th class="text-center">CPF</th>
            <th class="text-center">RG</th>
            <th class="text-left">E-Mail</th>
            <th class="text-left">Celular</th>
            <th class="text-left">Endereço</th>
            <th class="text-left">Bairro</th>
            <th class="text-left">Complemento</th>
            <th class="text-left">Número</th>
            <th class="text-left">Cep</th>
            <th class="text-left">Cidade</th>
            <th class="text-left">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in clientes" :key="i">
            <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
            <td class="text-left">{{item.sobrenome ? item.sobrenome : '-'}}</td>
            <td class="text-center">{{item.cpf ? item.cpf : '-'}}</td>
            <td class="text-center">{{item.rg ? item.rg : '-'}}</td>
            <td class="text-left">{{item.email ? item.email : '-'}}</td>
            <td class="text-left">{{item.celular ? item.celular : '-'}}</td>
            <td class="text-left">{{item.endereco ? item.endereco : '-'}}</td>
            <td class="text-left">{{item.bairro ? item.bairro : '-'}}</td>
            <td class="text-left">{{item.complemento ? item.complemento : '-'}}</td>
            <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
            <td class="text-left">{{item.cep ? item.cep : '-'}}</td>
            <td class="text-left">{{item.cidade ? item.cidade : '-'}}</td>
            <td class="text-left">{{item.estado ? item.estado : '-'}}</td>
          </tr>
        </tbody>
      </table>

      <div class="row mb-4">
        <div class="col-12 text-center">
          <button class="btn btn-success pr-5 pl-5" @click="addClientes()" :disabled="lojista_nome == ''">Adicionar clientes</button>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="light">
              <h4><b>Cliente(s) inserido(s)</b> ({{clientesCadastrados.length}})</h4>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <table class="table table-striped table-bordered" id="inseridos">
                <thead>
                  <tr>
                    <th class="text-left">Nome</th>
                    <th class="text-left">Sobrenome</th>
                    <th class="text-center">CPF</th>
                    <th class="text-center">RG</th>
                    <th class="text-left">E-Mail</th>
                    <th class="text-left">Celular</th>
                    <th class="text-left">Endereço</th>
                    <th class="text-left">Bairro</th>
                    <th class="text-left">Complemento</th>
                    <th class="text-left">Número</th>
                    <th class="text-left">Cep</th>
                    <th class="text-left">Cidade</th>
                    <th class="text-left">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in clientesCadastrados" :key="i">
                    <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
                    <td class="text-left">{{item.sobrenome ? item.sobrenome : '-'}}</td>
                    <td class="text-center">{{item.cpf ? item.cpf : '-'}}</td>
                    <td class="text-center">{{item.rg ? item.rg : '-'}}</td>
                    <td class="text-left">{{item.email ? item.email : '-'}}</td>
                    <td class="text-left">{{item.celular ? item.celular : '-'}}</td>
                    <td class="text-left">{{item.endereco ? item.endereco : '-'}}</td>
                    <td class="text-left">{{item.bairro ? item.bairro : '-'}}</td>
                    <td class="text-left">{{item.complemento ? item.complemento : '-'}}</td>
                    <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
                    <td class="text-left">{{item.cep ? item.cep : '-'}}</td>
                    <td class="text-left">{{item.cidade ? item.cidade : '-'}}</td>
                    <td class="text-left">{{item.estado ? item.estado : '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="light">
              <h4><b>Cliente(s) que já estava inserido ou dados incorretos</b> ({{clientesNaoCadastrados.length}})</h4>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <table class="table table-striped table-bordered" id="naoinseridos">
                <thead>
                  <tr>
                    <th class="text-left">Nome</th>
                    <th class="text-left">Sobrenome</th>
                    <th class="text-center">CPF</th>
                    <th class="text-center">RG</th>
                    <th class="text-left">E-Mail</th>
                    <th class="text-left">Celular</th>
                    <th class="text-left">Endereço</th>
                    <th class="text-left">Bairro</th>
                    <th class="text-left">Complemento</th>
                    <th class="text-left">Número</th>
                    <th class="text-left">Cep</th>
                    <th class="text-left">Cidade</th>
                    <th class="text-left">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in clientesNaoCadastrados" :key="i">
                    <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
                    <td class="text-left">{{item.sobrenome ? item.sobrenome : '-'}}</td>
                    <td class="text-center">{{item.cpf ? item.cpf : '-'}}</td>
                    <td class="text-center">{{item.rg ? item.rg : '-'}}</td>
                    <td class="text-left">{{item.email ? item.email : '-'}}</td>
                    <td class="text-left">{{item.celular ? item.celular : '-'}}</td>
                    <td class="text-left">{{item.endereco ? item.endereco : '-'}}</td>
                    <td class="text-left">{{item.bairro ? item.bairro : '-'}}</td>
                    <td class="text-left">{{item.complemento ? item.complemento : '-'}}</td>
                    <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
                    <td class="text-left">{{item.cep ? item.cep : '-'}}</td>
                    <td class="text-left">{{item.cidade ? item.cidade : '-'}}</td>
                    <td class="text-left">{{item.estado ? item.estado : '-'}}</td>
                  </tr>
                </tbody>
              </table>

              <div class="row mb-4">
                <div class="col-12 text-center">
                  <button class="btn btn-success pr-5 pl-5" @click="exportCSV()" :disabled="clientesNaoCadastrados.length == 0">
                    Baixar clientes
                  </button>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'ImportClientsExcel',
  mixins: [makeToast],
  data() {
    return {
      lojista_id: null,
      lojista_nome: '',
      clientes: null,
      clientesNaoCadastrados: [],
      clientesCadastrados: []
    };
  },
  methods: {
    exportCSV() {
      const rows = this.clientesNaoCadastrados.map((item) => {
        return [
          `"${item.nome || ''}"`,
          `"${item.sobrenome || ''}"`,
          `"${item.cpf || ''}"`,
          `"${item.rg || ''}"`,
          `"${item.email || ''}"`,
          `"${item.celular || ''}"`,
          `"${item.endereco || ''}"`,
          `"${item.bairro || ''}"`,
          `"${item.complemento || ''}"`,
          `"${item.numero || ''}"`,
          `"${item.cep || ''}"`,
          `"${item.cidade || ''}"`,
          `"${item.estado || ''}"`,
        ].join(',');
      });

      const csvData = [
        'nome,sobrenome,cpf,rg,email,celular,endereco,bairro,complemento,numero,cep,cidade,estado',
        ...rows,
      ].join('\n');

      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'clientes_nao_existe_banco.csv';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0]; // Assuming we have data in the first sheet
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          this.clientes = jsonData;
        };
        reader.readAsBinaryString(file);
      }
    },
    baixarExcel(){
      const url = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pre-cadastro-cliente.xlsx';
      window.open(url, "_blank");
    },
    buscarLojista() {
      this.lojista_nome = '';
      this.clientes = null;
      this.clientesNaoCadastrados = [];
      this.clientesCadastrados = [];

      if(this.lojista_id == '' || this.lojista_id == null) {
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/buscarLojinstaId', this.lojista_id)
        .then((response) => {
          if(response.data.nome_fantasia) {
            this.lojista_nome = response.data.nome_fantasia+' - CNPJ:'+response.data.cnpj;
          } else {
            this.lojista_id = null;
            this.makeToast('Oops', 'Lojista não encontrado!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    addClientes() {
      if(this.lojista_id == '' || this.lojista_id == null) {
        this.makeToast('Oops', 'Informe o lojista!', 'danger');
        return;
      }

      if(this.clientes.length == 0) {
        return;
      }

      const clientes = this.clientes.slice(0, 100);

      const data = {
        contrup_lojista_id: this.lojista_id,
        clientes: clientes
      }
      
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/addClientesExcel', data)
        .then((response) => {

          if(this.clientesNaoCadastrados.length == 0) {
            this.clientesNaoCadastrados = response.data.notAdd;
          } else { 
            const valor1 = this.clientesNaoCadastrados;
            const valor2 = response.data.notAdd;
            this.clientesNaoCadastrados = [...Object.values(valor1), ...valor2];
          }

          if(this.clientesCadastrados.length == 0) {
            this.clientesCadastrados = response.data.add;
          } else { 
            const valor1 = this.clientesCadastrados;
            const valor2 = response.data.add;
            this.clientesCadastrados = [...Object.values(valor1), ...valor2];
          }
          
        })
        .finally(() => {
          this.$store.dispatch('endLoader');

          this.clientes = this.clientes.slice(100);

          if(this.clientes.length > 0) {
            this.addClientes();
          }
        })
    }
  },
};
</script>

<style scoped>
#inseridos tr td, #inseridos tr th {
  border: 2px solid green !important;
}
#naoinseridos tr td, #naoinseridos tr th {
  border: 2px solid red !important;
}
</style>
